import Vue from 'vue'
import {
  Button, Rate, Switch, Search, Calendar,
  Cell, CellGroup, Icon, Toast, Tabbar,
  TabbarItem, NavBar, Dialog
  , ActionSheet
  , Form, Field
} from 'vant'

Toast.setDefaultOptions({ duration: 2000 })

Vue.use(Form)
Vue.use(Field)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Calendar)
Vue.use(Search)
Vue.use(Switch)
Vue.use(Rate)
Vue.use(Button)
Vue.use(Toast)
Vue.use(NavBar)

Vue.use(Cell)
Vue.use(CellGroup)

Vue.use(Icon)
